document.addEventListener('DOMContentLoaded', function() {
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartDrawerOverlay');
  var searchDrawer = document.getElementById('SearchDrawer');
  function openDrawer(){ if(drawer) drawer.classList.add('open'); if(overlay) overlay.classList.add('active'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(drawer) drawer.classList.remove('open'); if(overlay) overlay.classList.remove('active'); document.body.style.overflow=''; }
  window.openDrawer = openDrawer; window.closeDrawer = closeDrawer;
  document.querySelectorAll('[data-open-cart]').forEach(b=>b.addEventListener('click', e=>{ e.preventDefault(); openDrawer(); }));
  document.querySelectorAll('[data-close-cart]').forEach(b=>b.addEventListener('click', closeDrawer));
  if(overlay) overlay.addEventListener('click', closeDrawer);
  document.querySelectorAll('.size-btn').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      var g=btn.closest('.size-row'); if(g) g.querySelectorAll('.size-btn').forEach(x=>x.classList.remove('active'));
      btn.classList.add('active');
    });
  });
  var mOpen=document.getElementById('MobileOpen'), mClose=document.getElementById('MobileClose'), mMenu=document.getElementById('MobileMenu'), mOverlay=document.getElementById('MobileMenuOverlay');
  function openMobileMenu(){ if(mMenu) mMenu.classList.add('open'); if(mOverlay) mOverlay.classList.add('active'); document.body.style.overflow='hidden'; }
  function closeMobileMenu(){ if(mMenu) mMenu.classList.remove('open'); if(mOverlay) mOverlay.classList.remove('active'); document.body.style.overflow=''; }
  if(mOpen) mOpen.addEventListener('click', openMobileMenu);
  if(mClose) mClose.addEventListener('click', closeMobileMenu);
  if(mOverlay) mOverlay.addEventListener('click', closeMobileMenu);
  document.querySelectorAll('.mobile-nav-toggle').forEach(function(toggleBtn){
    toggleBtn.addEventListener('click', function(e){
      e.preventDefault();
      var navItem = toggleBtn.closest('.mobile-nav-item');
      if(!navItem) return;
      var subMenu = navItem.querySelector('.mobile-submenu');
      if(subMenu){
        subMenu.classList.toggle('open');
        toggleBtn.classList.toggle('open');
      }
    });
  });
  var sOpen=document.querySelectorAll('[data-open-search]'), sClose=document.getElementById('SearchClose');
  sOpen.forEach(b=>b.addEventListener('click', e=>{ e.preventDefault(); if(searchDrawer) searchDrawer.classList.add('open'); }));
  if(sClose&&searchDrawer) sClose.addEventListener('click', ()=>searchDrawer.classList.remove('open'));
  // announcement close
  var annClose=document.getElementById('CloseAnnouncement');
  if(annClose) annClose.addEventListener('click', ()=>{ document.querySelector('.top-bar').style.display='none'; localStorage.setItem('dbs_ann_closed','1'); });
  if(localStorage.getItem('dbs_ann_closed')=='1'){ var tb=document.querySelector('.top-bar'); if(tb) tb.style.display='none'; }
  // popup
  var popup=document.getElementById('NewsletterPopup');
  if(popup && !localStorage.getItem('dbs_popup_closed')){
    setTimeout(()=>{ popup.classList.add('active'); }, 3000);
  }
  document.querySelectorAll('[data-close-popup]').forEach(b=>b.addEventListener('click', ()=>{
    if(popup) popup.classList.remove('active'); localStorage.setItem('dbs_popup_closed','1');
  }));
  // video play
  document.querySelectorAll('.video-play-btn').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      var wrap=btn.closest('.video-section'); var vid=wrap.querySelector('video'); if(vid) { vid.play(); btn.style.display='none'; }
    });
  });
});

// Shopify Cart AJAX functionality
(function(){
  function formatMoney(cents) {
    if (typeof cents !== 'number') return cents;
    var val = (cents / 100).toFixed(2);
    return 'Rs.' + val.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  window.formatMoney = formatMoney;

  function refreshCartDrawer(callback) {
    var rootUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    fetch(rootUrl + 'cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('#CartCount, #CartDrawerCount');
        countEls.forEach(function(el) {
          el.innerText = cart.item_count;
          if (el.id === 'CartCount') {
            el.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
          }
        });

        var container = document.getElementById('CartDrawerItems');
        if (container) {
          if (cart.item_count === 0) {
            container.innerHTML = '<p style="font-size:13px">Your cart is currently empty.</p><a href="/collections/all" class="dz-btn" style="margin-top:12px">Continue Shopping</a>';
          } else {
            var html = '';
            cart.items.forEach(function(item) {
              var imgUrl = item.image ? item.image : '';
              var itemTitle = item.product_title || item.title;
              var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
              html += '<div style="display:flex;gap:12px;margin-bottom:18px" class="cart-drawer-item">' +
                (imgUrl ? '<img src="' + imgUrl + '" width="70" style="object-fit:cover;height:85px;background:#F8F5EF">' : '') +
                '<div style="font-size:12px;flex:1">' +
                  '<div style="text-transform:uppercase;letter-spacing:.06em;font-weight:600">' + itemTitle + '</div>' +
                  (variantTitle ? '<div style="color:#777;margin-top:2px">' + variantTitle + '</div>' : '') +
                  '<div style="margin-top:6px">' + item.quantity + ' × ' + formatMoney(item.price) + '</div>' +
                '</div>' +
                '<button type="button" class="cart-item-remove" data-key="' + item.key + '" style="background:none;border:none;font-size:11px;color:#999;cursor:pointer;align-self:flex-start">Remove</button>' +
              '</div>';
            });
            container.innerHTML = html;

            container.querySelectorAll('.cart-item-remove').forEach(function(btn) {
              btn.addEventListener('click', function(e) {
                e.preventDefault();
                var key = btn.getAttribute('data-key');
                changeCartItem(key, 0);
              });
            });
          }
        }

        var subtotalEl = document.getElementById('CartDrawerSubtotal');
        if (subtotalEl) {
          subtotalEl.innerText = formatMoney(cart.total_price);
        }

        if (typeof callback === 'function') callback(cart);
      })
      .catch(function(err) {
        console.error('Error refreshing cart:', err);
      });
  }
  window.refreshCartDrawer = refreshCartDrawer;

  function changeCartItem(key, qty) {
    var rootUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      refreshCartDrawer();
    });
  }
  window.changeCartItem = changeCartItem;

  function addToCart(variantId, quantity) {
    var btn = document.getElementById('AddToCartDBS');
    var selectedInput = document.getElementById('SelectedVariant');
    var form = document.getElementById('product-form-dbs');
    
    var idToAdd = variantId;
    if (!idToAdd && selectedInput) idToAdd = selectedInput.value;
    if (!idToAdd && form) {
      var input = form.querySelector('[name="id"]');
      if (input) idToAdd = input.value;
    }

    if (!idToAdd) {
      alert('Please select a size / variant before adding to cart.');
      return;
    }

    var originalText = btn ? btn.innerText : 'Add to Cart';
    if (btn) {
      btn.innerText = 'ADDING...';
      btn.disabled = true;
    }

    var rootUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(idToAdd, 10),
        quantity: quantity || 1
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status || data.errors) {
        alert(data.description || data.message || 'Could not add product to cart.');
        if (btn) {
          btn.innerText = originalText;
          btn.disabled = false;
        }
        return;
      }
      refreshCartDrawer(function() {
        if (btn) {
          btn.innerText = 'ADDED TO CART!';
        }
        setTimeout(function() {
          if (btn) {
            btn.innerText = originalText;
            btn.disabled = false;
          }
        }, 1200);
        if (typeof window.openDrawer === 'function') window.openDrawer();
      });
    })
    .catch(function(err) {
      console.error('Add to Cart error:', err);
      alert('An error occurred while adding product to cart.');
      if (btn) {
        btn.innerText = originalText;
        btn.disabled = false;
      }
    });
  }
  window.addToCart = addToCart;

  function quickAddToCart(variantId, btnElement) {
    if (!variantId) return;
    var originalText = btnElement ? btnElement.innerText : '+ Quick Add';
    if (btnElement) {
      btnElement.innerText = 'ADDING...';
      btnElement.disabled = true;
      btnElement.style.opacity = '0.7';
    }

    var rootUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status || data.errors) {
        alert(data.description || data.message || 'Could not add product to cart.');
        if (btnElement) {
          btnElement.innerText = originalText;
          btnElement.disabled = false;
          btnElement.style.opacity = '1';
        }
        return;
      }
      refreshCartDrawer(function() {
        if (btnElement) {
          btnElement.innerText = 'ADDED!';
        }
        setTimeout(function() {
          if (btnElement) {
            btnElement.innerText = originalText;
            btnElement.disabled = false;
            btnElement.style.opacity = '1';
          }
        }, 1200);
        if (typeof window.openDrawer === 'function') window.openDrawer();
      });
    })
    .catch(function(err) {
      console.error('Quick Add to Cart error:', err);
      alert('An error occurred while adding product to cart.');
      if (btnElement) {
        btnElement.innerText = originalText;
        btnElement.disabled = false;
        btnElement.style.opacity = '1';
      }
    });
  }
  window.quickAddToCart = quickAddToCart;
})();
